import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { useSelector } from "react-redux";
import { Button, Grid, Typography , Menu , MenuItem , TextField , Box, ButtonGroup, InputAdornment, Pagination } from "@mui/material";
import {ListAlt ,SignalCellularAlt , AirportShuttle, Search, FilterList} from "@mui/icons-material";
import { DataGrid  } from "@mui/x-data-grid";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import io from "socket.io-client";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useFormik, useField } from "formik";
import * as yup from "yup";
import _ from "lodash";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from 'moment-timezone';
//Services
import TriplistApi from "Services/Triplist";
import ServiceApi from "Services/Service";
import Passengerhistorydetails from "Pages/Modals/Passengerhistory/Moredetails";
import { CUSTOM_CONSTANTS } from "Constants/index";


const Passenger = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [row, setRow] = useState([]);
  const [searchText, setSearchText] = useState("");
  const timezone = useSelector((state) => state.timezone.timezone);
  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openaction = Boolean(anchorEl);
  const Tripstatus = ["CANCELLED", "COMPLETED", "SCHEDULED"];
  const Paymentmethod = ["CASH", "CARD", "CORPORATE"];
  const [servicesData, setServicesData] = useState([]);
  const [filtervalues , setFiltervalues] = useState({});
  const [moredetailsmodel, setmoredetailsModal] = useState(false);
  const [requestId, setrequestId] = useState("");
  const [metrics,setmetrics] = useState({});
  const [bulkrow, setbulkrow] = useState([]);

  // Fetch services list for filter dropdown
  useEffect(() => {
    ServiceApi.getServices({ limit: "unlimited" })
      .then((res) => {
        if (res?.data?.data?.data) {
          setServicesData(res.data.data.data);
        }
      })
      .catch((err) => console.log("Failed to fetch services", err));
  }, []);

  // Get Passenger list api

  const gettriplists = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
   // console.log('filtervalues-->',filtervalues);
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
       // console.log('Overall--->',res?.data);
        setRow(res?.data?.data?.data.triplists);
          setbulkrow(res?.data?.data?.data.triplists);
        setmetrics({
          totalRidesCount: res?.data?.data.totalRidesCount,
          cancelledRides: res?.data?.data.cancelledRides,
          totalRevenue: res?.data?.data.totalRevenue,
        });

        console.log('metrics--->',res?.data?.data); 
      } else {
        setRow([]);
        setbulkrow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    TriplistApi.getoverallstatement({ page, limit: pageSize , filtervalues })
      .then(onSuccess, onFailure);
  }, [page, pageSize, filtervalues]);
  

  useEffect(() => {
    gettriplists();
  }, [gettriplists]);


  const handlePageChange = (newPage) => {
   // console.log('newPage-->',newPage);
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  function formatDate(inputDate) {
    if (!inputDate) {
      return "--"; // Return '--' if inputDate is null or undefined
    }
    
  return moment(inputDate).tz(timezone).format("YYYY-MM-DD hh:mm A");

  }

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const handleview = (event, rowData) => {
   // console.log('rowData-->',rowData)
    setrequestId(rowData?._id);
    setmoredetailsModal(true);
  };
 
  const handleClosemoredetailsModal = () => {
    setmoredetailsModal(false);
    gettriplists();
  };

  const filteredRow = (row || []).filter((data) => {
    if (!searchText) return true;
    const searchLower = searchText.toLowerCase();
    const passengerName = `${data?.userdetails?.firstName || ""} ${data?.userdetails?.lastName || ""}`.toLowerCase();
    const driverName = data?.driverdetails ? `${data.driverdetails.firstName || ""} ${data.driverdetails.lastName || ""}`.toLowerCase() : "not exists";
    return (
      data?.bookingId?.toLowerCase().includes(searchLower) ||
      data?.pickupAddress?.toLowerCase().includes(searchLower) ||
      data?.dropAddress?.toLowerCase().includes(searchLower) ||
      data?.tripStatus?.toLowerCase().includes(searchLower) ||
      data?.paymentMode?.toLowerCase().includes(searchLower) ||
      passengerName.includes(searchLower) ||
      driverName.includes(searchLower)
    );
  });

  const dataRows = _.map(filteredRow || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    pickuplocation: data?.pickupAddress,
    stop1address:data?.stop1_address,
    stop2address:data?.stop2_address,
    bookingId: data?.bookingId,
    droplocation: data?.dropAddress,
    requestedAt: formatDate(data?.requestedAt),
    status:data?.tripStatus,
    Paymentmode:data?.paymentMode,
    Total:data?.estimatedFare.toFixed(2),
    commission:data?.earnedCommission,
    driverearned:data?.driverEarnings && data?.tripStatus=="COMPLETED" ? (data?.driverEarnings?.earnings ?? 0).toFixed(2):0,
    statusbackground:data?.tripStatus ? 
    data?.tripStatus == "COMPLETED" ? "#00c292" : 
    data?.tripStatus == "CANCELLED" ? "#f8312fd6" : "#2d7ea8"
    : "#2d7ea8",
    row: data,
  }));

   const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "First Name":row.firstName,
    "Email":row.email,
    "Mobile": row.mobile,
    "Rating": row.rating,
    "Corporate": row.corporate
  }));


    const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ['createdAt'], ['asc']),
    (data, index) => ({
      sno: calculateSno(page, pageSize, index),
      firstName: data?.firstName,
      email: data?.email,
      mobile: data?.countryCode+" "+data?.mobileNumber,
      rating: data?.rating,
      corporate: data?.corporate_user_id ? "YES" : "NO",
      row: data,
    }));  
  
    const bulkformatteddatas = bulkdataRows.map((row) => ({
      "S.NO": row.sno,
      "First Name":row.firstName,
      "Email":row.email,
      "Mobile": row.mobile,
      "Rating": row.rating,
      "Corporate": row.corporate
    }));
  

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex: 1,
      minWidth: 60, 
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "bookingId",
      headerName: "Booking ID",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.bookingId}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "pickuplocation",
      headerName: "Picked up",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.pickuplocation}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "stop1address",
      headerName: "Stop 1",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.stop1address || "--"}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "stop2address",
      headerName: "Stop 2",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.stop2address || "--"}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "droplocation",
      headerName: "Drop location",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.droplocation}</Typography>
            </div>
          </>
        );
      },
    },
    {
    field: "actions",
    headerName: "Request Details",
    minWidth: 150, // Minimum column width
    resizable: true, // Allow users to resize
    sortable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
      const rowData = params?.row?.row;
      return (
        <>
    <div className={classes.iconsWrapper}>
    <Button
      id="basic-button"
      aria-controls={openaction ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={openaction ? 'true' : undefined}
      onClick={(e) => handleview(e, rowData)}
    >
      View
    </Button>
        </div>
        </>
      );
    },
    }, 
    {
      field: "requestedAt",
      headerName: "Dated on",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.requestedAt}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography className={classes.status} 
              sx={{ background: params?.row?.statusbackground }}
              variant="body2">{params?.row?.status}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "Paymentmode",
      headerName: "Payment Mode",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.Paymentmode}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "Total",
      headerName: "Total",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{CUSTOM_CONSTANTS.BASE_CURRENCY} {params?.row?.Total}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "commission",
      headerName: "Commission",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{CUSTOM_CONSTANTS.BASE_CURRENCY} {params?.row?.commission}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "driverearned",
      headerName: "Earned by driver",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{CUSTOM_CONSTANTS.BASE_CURRENCY} {params?.row?.driverearned}</Typography>
            </div>
          </>
        );
      },
    },
  ];

  // handle dates

const handlefromdate = (newValue) => {
  if (newValue === null || newValue === "") {
    formik.setFieldValue("fromdate", newValue);
  } else {
    const selectedDate =
      newValue instanceof Date ? newValue : new Date(newValue);
    const parsedDate = moment(selectedDate);
    const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
    formik.setFieldValue("fromdate", formattedDate);
  }
};

const handletodate = (newValue) => {
  if (newValue === null || newValue === "") {
    formik.setFieldValue("todate", newValue);
  } else {
    const selectedDate =
      newValue instanceof Date ? newValue : new Date(newValue);
    const parsedDate = moment(selectedDate);
    const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
    formik.setFieldValue("todate", formattedDate);
  }
};

  // filter form 

  function convertToISO(inputDate) {
    if (!inputDate) {
      return "--"; // Handle null or undefined input
    }
  
    // Parse the input date string
    const date = new Date(inputDate);
  
    if (isNaN(date.getTime())) {
      return "--"; // Handle invalid date formats
    }
  
    // Convert to ISO string and replace "Z" with "+00:00" for UTC offset
    const isoString = date.toISOString().replace("Z", "+00:00");
    return isoString;
  }
  

const handlefiltertriplist = (formValues) => {
   
  formValues.fromdate = convertToISO(formValues.fromdate);
  formValues.todate = convertToISO(formValues.todate);
 // console.log('formValues-->',formValues);
 // dispatch(showLoader("Loading please wait..."));
  setFiltervalues(formValues);
  };

  const formik = useFormik({
    initialValues: {
      tripStatus: "",
      paymentMode: "",
      serviceTypeId: "",
      fromdate: "",
      todate: "",
    },
    validationSchema: yup.object({
      fromdate: yup.string().required("Status is required").nullable(),
      todate: yup.string().required("Service is required").nullable(),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      handlefiltertriplist(values); // Ensure this processes `values` correctly
    },
  });


    const handleCopy = () => {
        // Define column widths
        const columnWidths = [5, 15, 25, 15, 15, 15]; // Adjust widths as needed
    
        // Helper function to pad text to the desired width
        const padText = (text, width) => {
          return (text ?? "").toString().padEnd(width, " ");
        };
        // Create table header
        const header = [
          padText("S.NO", columnWidths[0]),
          padText("First name", columnWidths[1]),
          padText("Email", columnWidths[2]),
          padText("Mobile", columnWidths[3]),
          padText("Rating", columnWidths[4]),
          padText("Corporate", columnWidths[5]),
        ].join("");
      
        // Create table rows
        const rows = dataRows
          .map((row) =>
            [
              padText(row.sno, columnWidths[0]),
              padText(row.firstName, columnWidths[1]),
              padText(row.email, columnWidths[2]),
              padText(row.mobile, columnWidths[3]),
              padText(row.rating, columnWidths[4]),
              padText(row.corporate, columnWidths[5]),
            ].join("")
          )
          .join("\n");
      
        // Combine header and rows
        const formattedContent = [header, rows].join("\n");
      
        // Copy to clipboard
        navigator.clipboard.writeText(formattedContent).then(() => {
          alert("Table copied to clipboard!");
        });
    };
  
    const handleDownloadExcel = () => {
      const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
      XLSX.writeFile(workbook, "OverAllreport.xlsx");
    };
  
    const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "OverAllreport.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    };
  
    const handleDownloadPDF = () => {
      const doc = new jsPDF();
      const tableData = dataRows.map((row) => [
        row.sno,
        row.firstName,
        row.email,
        row.mobile,
        row.rating,
        row.corporate
      ]);
      doc.autoTable({
        head: [["S.NO","First Name","Email","Mobile","Rating","Corporate"]],
        body: tableData,
      });
      doc.save("Ovarallreport.pdf");
    };
  
      const handleDownloadAll = () => {
        const csv = Papa.unparse(bulkformatteddatas);
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "OverAllReports.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
    
  const CustomPagination = () => {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 3, borderTop: '1px solid #e0e0e0', width: '100%', boxSizing: 'border-box' }}>
        <Typography variant="body2" sx={{ color: '#6c757d', fontSize: '14px', fontWeight: 500 }}>
          Showing {((page - 1) * pageSize) + 1} to {Math.min(page * pageSize, totalPages)} of {totalPages} results
        </Typography>
        <Pagination
          count={Math.ceil(totalPages / pageSize) || 1}
          page={page}
          onChange={(event, value) => {
             setPage(value);
             handlePageChange(value - 1); 
          }}
          shape="rounded"
          sx={{
            "& .MuiPaginationItem-root": {
               border: 'none',
               fontWeight: 500,
            },
            "& .Mui-selected": {
               backgroundColor: "#2a2d34 !important",
               color: "#fff",
            }
          }}
        />
      </Box>
    );
  };

  return (  
    <>

<div className={classes.pages}>
<Grid container className={classes.root}>

<Grid item xs={12} className={classes.headerSection}>
  <Typography variant="h4" className={classes.pageTitle}>Overall Ride Statement</Typography>
  <div className={classes.searchContainer}>
    <TextField
      placeholder="Search"
      size="small"
      value={searchText}
      onChange={(e) => {
        setSearchText(e.target.value);
        setPage(1);
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search color="action" />
          </InputAdornment>
        ),
      }}
      className={classes.searchInput}
    />
  </div>
</Grid>

<Grid container className={classes.metricboxes} spacing={3}>
  <Grid item xs={4}>
    <Box className={classes.metricboxCard}>
      <div className={classes.metricboxContent}>
        <Typography className={classes.metricTitle}>Total No. Of Rides</Typography>
        <Typography className={classes.metricValue}>{metrics?.totalRidesCount?.toString()?.padStart(2, '0') || '00'}</Typography>
      </div>
      <img src="/assets/images/Dashboardiconnew/totalrides.png" alt="Rides" className={classes.metricIcon} />
    </Box>
  </Grid>
  <Grid item xs={4}>
    <Box className={classes.metricboxCard}>
      <div className={classes.metricboxContent}>
        <Typography className={classes.metricTitle}>Revenue</Typography>
        <Typography className={classes.metricValue}>{CUSTOM_CONSTANTS.BASE_CURRENCY}{metrics?.totalRevenue || '0'}</Typography>
      </div>
      <img src="/assets/images/Dashboardiconnew/revenuetotal.png" alt="Revenue" className={classes.metricIcon} />
    </Box>
  </Grid>
  <Grid item xs={4}>
    <Box className={classes.metricboxCard}>
      <div className={classes.metricboxContent}>
        <Typography className={classes.metricTitle}>Cancelled Rides</Typography>
        <Typography className={classes.metricValue}>{metrics?.cancelledRides?.toString()?.padStart(2, '0') || '00'}</Typography>
      </div>
      <img src="/assets/images/Dashboardiconnew/totalcancelride.png" alt="Cancelled" className={classes.metricIcon} />
    </Box>
  </Grid>
</Grid>

<Grid container className={classes.utilities} alignItems="center">
  <Grid item xs={12} md={7} lg={7} className={classes.filtersContainer}>
    <TextField
      name="tripStatus"
      id="tripStatus"
      select
      value={formik?.values?.tripStatus || ""}
      onChange={formik?.handleChange}
      variant="outlined"
      size="small"
      SelectProps={{ displayEmpty: true }}
      className={classes.roundedFilter}
    >
      <MenuItem key="All status" value="">
        All Status
      </MenuItem>
      {Tripstatus.map((status) => (
        <MenuItem key={status} value={status}>
          {status}
        </MenuItem>
      ))}
    </TextField>

    <TextField
      name="serviceTypeId"
      id="serviceTypeId"
      select
      value={formik?.values?.serviceTypeId || ""}
      onChange={formik?.handleChange}
      variant="outlined"
      size="small"
      SelectProps={{ displayEmpty: true }}
      className={classes.roundedFilter}
    >
      <MenuItem key="All services" value="">
        All Services
      </MenuItem>
      {servicesData.map((service) => (
        <MenuItem key={service._id} value={service._id}>
          {service.serviceName}
        </MenuItem>
      ))}
    </TextField>

    <TextField
      name="paymentMode"
      id="paymentMode"
      select
      value={formik?.values?.paymentMode || ""}
      onChange={formik?.handleChange}
      variant="outlined"
      size="small"
      SelectProps={{ displayEmpty: true }}
      className={classes.roundedFilter}
    >
      <MenuItem key="All payment" value="">
        All Payments
      </MenuItem>
      {Paymentmethod.map((booking) => (
        <MenuItem key={booking} value={booking}>
          {booking}
        </MenuItem>
      ))}
    </TextField>

    <div className={classes.datePickerStyle}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={formik?.values?.fromdate || null}
          onChange={(newValue) => {
            handlefromdate(newValue);
          }}
          renderInput={(params) => (
            <TextField {...params} size="small" placeholder="From Date" className={classes.roundedFilter} />
          )}
        />
      </LocalizationProvider>
    </div>

    <div className={classes.datePickerStyle}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={formik?.values?.todate || null}
          onChange={(newValue) => {
            handletodate(newValue);
          }}
          renderInput={(params) => (
            <TextField {...params} size="small" placeholder="To Date" className={classes.roundedFilter} />
          )}
        />
      </LocalizationProvider>
    </div>
  </Grid>

  <Grid item xs={12} md={5} lg={5} className={classes.actionsContainer}>
    <ButtonGroup variant="contained" className={classes.buttonGroup}>
      <Button onClick={handleCopy}>Copy</Button>
      <Button onClick={handleDownloadExcel}>Excel</Button>
      <Button onClick={handleDownloadCSV}>CSV</Button>
      <Button onClick={handleDownloadPDF}>PDF</Button>
    </ButtonGroup>
    <Button 
      variant="contained" 
      className={classes.moreFiltersBtn} 
      startIcon={<FilterList />}
      onClick={formik?.handleSubmit}
    >
      More Filters
    </Button>
  </Grid>
</Grid>

<Grid item xs={12}>
    <section className={classes.dataGridTable}>
      <DataGrid
       className={classes.tripgridtable}
        getRowId={(row) => row?.row?._id}
        rows={dataRows}
        columns={columns}
        pageSize={pageSize}
        components={{
          Footer: CustomPagination,
        }}
        onPageSizeChange={(newPageSize) => {
         // console.log("newPageSize--->",newPageSize);
          setPageSize(newPageSize);
          setPage(1);
        }}
        onPageChange={(newPage) => handlePageChange(newPage)}
        rowsPerPageOptions={[5, 10, 25, 50]}
        pagination
        autoHeight={true}
        disableSelectionOnClick
        scrollbarSize={4}
        rowHeight={100}
        style={{ padding: "10px", borderRadius: "0px" }}
        paginationMode="server"
        rowCount={totalPages}
      />
    </section>
</Grid>

</Grid>
<Passengerhistorydetails
        openDialog={moredetailsmodel}
        id={requestId}
        handleClose={handleClosemoredetailsModal}
></Passengerhistorydetails>
</div>

    </>
  );
};

export default Passenger;
